import { ComboboxItem, Group } from '@mantine/core'
import { useParams } from 'react-router-dom'
import { InputTag } from './InputTag'
import { TagBadge } from './TagBadge'

export const AssignedTagsList = ({ data }: { data: ComboboxItem[] }) => {
  const { deviceId } = useParams()

  return (
    <Group gap={5}>
      {data.map(tag => (
        <TagBadge deviceId={deviceId!} key={tag.value} {...tag} />
      ))}
      <InputTag
        deviceId={deviceId!}
        assignedTags={data.map(tag => tag.value)}
      />
    </Group>
  )
}
